<div class="so-week-day-picker" [class.so-week-day-picker--disabled]="isDisabled()">
  @if (label()) {
    <label class="so-week-day-picker__label">{{ label() }}</label>
  }

  <div 
    class="so-week-day-picker__days"
    [class.so-week-day-picker__days--sm]="size() === 'sm'"
    [class.so-week-day-picker__days--lg]="size() === 'lg'">
    @for (day of weekDays(); track day.key) {
      <button
        type="button"
        class="so-week-day-picker__day"
        [class.so-week-day-picker__day--selected]="isSelected(day.key)"
        [class.so-week-day-picker__day--disabled]="isDisabled() || isDayDisabled(day.key)"
        [disabled]="isDisabled() || isDayDisabled(day.key)"
        [attr.aria-pressed]="isSelected(day.key)"
        [attr.aria-label]="day.label"
        [title]="isDayDisabled(day.key) ? 'Día no disponible' : day.label"
        (click)="toggleDay(day.key)">
        <span class="so-week-day-picker__day-label">{{ day.shortLabel }}</span>
        @if (showLabels()) {
          <span class="so-week-day-picker__day-name">{{ day.label }}</span>
        }
      </button>
    }
  </div>
</div>
